<template>
  <div class="bi-dashboard-box">
    <data-input
      v-model="timeframe"
      :options="{
        day: 'Letzte 24 Std.',
        week: 'Letzte 7 Tage',
        month: 'Letzter Monat',
        all: 'Gesamt'
      }"
      label="Zeitraum"
      name="timeframe"
      type="select"
    />
    <div v-if="timeframe != 'all'" class="vx-row w-full mt-3">
      <div class="vx-col w-full lg:w-1/2">
        <DataInput
          class="px-2 inline-block"
          type="date"
          name="daterange"
          label="Zeitraum"
          :value="defaultDate"
          :config="{
            altFormat: 'd.m.Y H:i',
            dateFormat: 'Y-m-d H:i',
            mode: 'range'
          }"
          @input="updateDates"
        />
      </div>
      <div class="vx-col w-full lg:w-1/12">
        <data-input
          v-model="internalValue.doComparision"
          name="doComparision"
          type="bool"
          label="Vergleichen"
        />
      </div>
      <div class="vx-col w-full lg:w-5/12">
        <DataInput
          v-if="internalValue.doComparision"
          class="px-2 inline-block"
          type="date"
          name="daterange"
          label="Zeitraum"
          :value="defaultCompare"
          :config="{
            altFormat: 'd.m.Y H:i',
            dateFormat: 'Y-m-d H:i',
            mode: 'range'
          }"
          @input="updateCompares"
        />
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import DataInput from "@/components/ui/DataInput";

export default {
  components: {
    DataInput
  },
  data() {
    return {
      internalValue: {
        timeframe: {
          from: null,
          to: null
        },
        doComparision: false,
        compareTo: {
          from: null,
          to: null
        }
      },
      timeframe: "all",
      dateInputConfig: {
        altFormat: "d.m.Y H:i",
        dateFormat: "Y-m-d H:i",
        enableTime: true,
        time_24hr: true
      }
    };
  },
  computed: {
    defaultDate() {
      if (
        this.internalValue.timeframe.from &&
        this.internalValue.timeframe.to
      ) {
        return (
          moment(this.internalValue.timeframe.from).toISOString() +
          " bis " +
          moment(this.internalValue.timeframe.to).toISOString()
        );
      }
      return null;
    },
    defaultCompare() {
      if (
        this.internalValue.compareTo.from &&
        this.internalValue.compareTo.to
      ) {
        return (
          moment(this.internalValue.compareTo.from).toISOString() +
          " bis " +
          moment(this.internalValue.compareTo.to).toISOString()
        );
      }
      return null;
    }
  },
  watch: {
    timeframe(value) {
      switch (value) {
        case "day":
          this.internalValue.timeframe.from = moment().subtract(1, "days");
          this.internalValue.timeframe.to = moment();
          break;
        case "week":
          this.internalValue.timeframe.from = moment().subtract(7, "days");
          this.internalValue.timeframe.to = moment();
          break;
        case "month":
          this.internalValue.timeframe.from = moment().subtract(30, "days");
          this.internalValue.timeframe.to = moment();
          break;
        case "all":
          this.internalValue.timeframe.from = null;
          this.internalValue.timeframe.from = null;
          this.internalValue.doComparision = false;
          break;
        default:
          break;
      }
    },
    internalValue: {
      deep: true,
      immidiate: true,
      handler(initialValue) {
        let value = JSON.parse(JSON.stringify(initialValue));
        if (value.timeframe.to) {
          value.timeframe.to = moment(value.timeframe.to);
        }
        if (value.timeframe.from) {
          value.timeframe.from = moment(value.timeframe.from);
        }
        if (value.compareTo.to) {
          value.compareTo.to = moment(value.compareTo.to);
        }
        if (value.compareTo.from) {
          value.compareTo.from = moment(value.compareTo.from);
        }
        this.$emit("input", value);
      }
    },
    "internalValue.doComparision"(value) {
      if (value) {
        this.internalValue.compareTo.from = moment(
          this.internalValue.timeframe.to
        ).clone();
        this.internalValue.compareTo.to = moment(
          this.internalValue.compareTo.from
        )
          .clone()
          .add(
            moment.duration(
              moment(this.internalValue.timeframe.to).diff(
                this.internalValue.timeframe.from
              )
            )
          );
      } else {
        this.internalValue.compareTo.to = null;
        this.internalValue.compareTo.from = null;
      }
    }
  },
  methods: {
    updateDates(value) {
      if (value.includes(" bis ")) {
        const [from, to] = value.split(" bis ");
        this.internalValue.timeframe = {
          from: moment(from),
          to: moment(to)
        };
      }
    },
    updateCompares(value) {
      if (value.includes(" bis ")) {
        const [from, to] = value.split(" bis ");
        this.internalValue.compareTo = {
          from: moment(from),
          to: moment(to)
        };
      }
    }
  },
  emits: ["input"]
};
</script>
